"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseProxyError = exports.TemporaryRedirectError = exports.SeeOtherError = exports.PermanentRedirectError = exports.NotModifiedError = exports.MultipleChoicesError = exports.MovedError = exports.FoundError = void 0;
const BaseError_1 = require("./BaseError");
const ErrorCodes_1 = require("./ErrorCodes");
class FoundError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.FoundError, message);
    }
}
exports.FoundError = FoundError;
class MovedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.MovedError, message);
    }
}
exports.MovedError = MovedError;
class MultipleChoicesError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.MultipleChoicesError, message);
    }
}
exports.MultipleChoicesError = MultipleChoicesError;
class NotModifiedError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.NotModifiedError, message);
    }
}
exports.NotModifiedError = NotModifiedError;
class PermanentRedirectError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.PermanentRedirectError, message);
    }
}
exports.PermanentRedirectError = PermanentRedirectError;
class SeeOtherError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.SeeOtherError, message);
    }
}
exports.SeeOtherError = SeeOtherError;
class TemporaryRedirectError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.TemporaryRedirectError, message);
    }
}
exports.TemporaryRedirectError = TemporaryRedirectError;
class UseProxyError extends BaseError_1.BaseError {
    constructor(message) {
        super(ErrorCodes_1.ErrorCodes.UseProxyError, message);
    }
}
exports.UseProxyError = UseProxyError;
//# sourceMappingURL=RedirectErrors.js.map